import React from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Box, Card, CardContent, CircularProgress, Typography } from "@mui/material";

export default function PublicMusicLyric() {
  const { token } = useParams();
  const [state, setState] = React.useState({ loading: true, err: "", title: "", text: "" });

  React.useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/music/public/lyric/${encodeURIComponent(token || "")}`,
        );
        if (cancelled) return;
        if (!res.data?.success) {
          setState({ loading: false, err: "Not found or not shared.", title: "", text: "" });
          return;
        }
        const d = res.data.data || {};
        setState({
          loading: false,
          err: "",
          title: d.title || "",
          text: d.lyrics_text || "",
        });
      } catch {
        if (!cancelled) setState({ loading: false, err: "Could not load this page.", title: "", text: "" });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (state.loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (state.err) {
    return (
      <Box sx={{ maxWidth: 720, mx: "auto", py: 6, px: 2 }}>
        <Typography color="text.secondary">{state.err}</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ maxWidth: 720, mx: "auto", py: 4, px: 2 }}>
      <Card variant="outlined">
        <CardContent>
          <Typography variant="h5" gutterBottom>
            {state.title || "Shared lyrics"}
          </Typography>
          <Typography
            component="pre"
            sx={{
              whiteSpace: "pre-wrap",
              fontFamily: "inherit",
              fontSize: "0.95rem",
              lineHeight: 1.65,
              mt: 2,
            }}
          >
            {state.text}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}
